import { render } from "./ChooseForm.vue?vue&type=template&id=7dfc9964&scoped=true&ts=true"
import script from "./ChooseForm.vue?vue&type=script&lang=ts"
export * from "./ChooseForm.vue?vue&type=script&lang=ts"

import "./ChooseForm.vue?vue&type=style&index=0&id=7dfc9964&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfc9964"]])

export default __exports__